import { Button } from '@zep-us/zus';
import { BoltFillColorVioletIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { openAiBuilderPaywallModal } from '../utils/openAiBuilderPaywallModal';

/**
 * 무료 대화 횟수 소진 안내 카드 — 채팅 기회가 0이 되었을 때 composer 위에 표시.
 * 시안: Figma (39095:110807) — 흰 배경 + violet 테두리 + shadow, ⚡ 아이콘 +
 * 소진 제목/설명 + "플랜 가격 확인하기" gradient 버튼.
 * 버튼 기본 동작은 채팅 컨텍스트를 유지한 채 기존 paywall(UpsellingModal)을 오버레이로 연다.
 */
export const AiBuilderUsageExhaustedCard = ({
  onCheckPlans = openAiBuilderPaywallModal
}: {
  onCheckPlans?: () => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex w-full items-center gap-sm rounded-md border-2 border-transparent px-md py-lg shadow-xl"
  // 시안 stroke: gradient/violet-blue(violet400→blue400) 2px inside.
  // ZUS에 gradient border 토큰이 없어 padding-box/border-box 기법으로 구현.
  style={{
    background: 'linear-gradient(#ffffff, #ffffff) padding-box, linear-gradient(90deg, #8478ff, #3da9ff) border-box'
  }} data-sentry-component="AiBuilderUsageExhaustedCard" data-sentry-source-file="AiBuilderUsageExhaustedCard.tsx">
      <BoltFillColorVioletIcon size="lg" data-sentry-element="BoltFillColorVioletIcon" data-sentry-source-file="AiBuilderUsageExhaustedCard.tsx" />
      <div className="flex min-w-0 flex-1 flex-col items-start gap-4xs">
        <p className="w-full text-body-lg-bold text-default">
          {t('build:aiBuilderChat.usage.blocked')}
        </p>
        <p className="w-full text-body-md-medium text-neutral">
          {t('build:aiBuilderChat.usage.exhaustedDescription')}
        </p>
      </div>
      <Button type="button" variant="contained" intent="gradient" size="md" rounded="default" onClick={onCheckPlans} data-sentry-element="Button" data-sentry-source-file="AiBuilderUsageExhaustedCard.tsx">
        {t('build:aiBuilderChat.usage.checkPlans')}
      </Button>
    </div>;
};